"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixExcessiveSlashing = void 0;
const fixExcessiveSlashing = input => input.replace(/\/+/g, '/');
exports.fixExcessiveSlashing = fixExcessiveSlashing;
//# sourceMappingURL=fixExcessiveSlashing.js.map